import { render } from "./vsetderivativeslist.vue?vue&type=template&id=0cb3cd00&scoped=true"
import script from "./vsetderivativeslist.vue?vue&type=script&lang=js"
export * from "./vsetderivativeslist.vue?vue&type=script&lang=js"

import "./vsetderivativeslist.vue?vue&type=style&index=0&id=0cb3cd00&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb3cd00"]])

export default __exports__